/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Category_Field_LabelInputs */

const vi_product_category_field_label = /** @type {(inputs: Product_Category_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh mục`)
};

/**

* @param {Product_Category_Field_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_category_field_label = /** @type {((inputs?: Product_Category_Field_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Category_Field_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_category_field_label(inputs)
});